module.exports = __webpack_public_path__ + "media/images/iconSocialFacebook__accent-5d27e27c600ed264a7f886ec8dafc8cd.png";